import { Link } from 'react-router-dom';
import { rankings } from '@/mocks/rankings';

export default function RankingPreview() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">实时排行</span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            全国排行榜
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            每周更新排名数据，展示全国顶尖选手的竞技实力。下一个上榜的，也许就是你！
          </p>
        </div>

        <div className="bg-background-50 rounded-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left px-6 py-4 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">排名</th>
                  <th className="text-left px-6 py-4 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">选手</th>
                  <th className="text-left px-6 py-4 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">地区</th>
                  <th className="text-right px-6 py-4 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">积分</th>
                  <th className="text-right px-6 py-4 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">胜率</th>
                  <th className="text-right px-6 py-4 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">场次</th>
                  <th className="text-right px-6 py-4 text-xs font-semibold text-foreground-500 uppercase whitespace-nowrap">变化</th>
                </tr>
              </thead>
              <tbody>
                {rankings.map((entry) => (
                  <tr key={entry.rank} className="border-b border-background-100 hover:bg-background-50 transition-colors">
                    <td className="px-6 py-4">
                      <span className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold ${
                        entry.rank === 1 ? 'bg-accent-500 text-background-50' :
                        entry.rank === 2 ? 'bg-secondary-400 text-background-50' :
                        entry.rank === 3 ? 'bg-accent-700 text-background-50' :
                        'bg-background-200 text-foreground-600'
                      }`}>
                        {entry.rank}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-sm font-semibold text-foreground-900">{entry.name}</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-sm text-foreground-600">{entry.region}</span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <span className="text-sm font-semibold text-foreground-900">{entry.score.toLocaleString()}</span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <span className="text-sm text-foreground-600">{entry.winRate}</span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <span className="text-sm text-foreground-600">{entry.matches}</span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      {entry.change === 'up' ? (
                        <span className="inline-flex items-center gap-1 text-primary-600 text-sm font-medium">
                          <i className="ri-arrow-up-s-line"></i>
                          {entry.changeValue}
                        </span>
                      ) : entry.change === 'down' ? (
                        <span className="inline-flex items-center gap-1 text-red-500 text-sm font-medium">
                          <i className="ri-arrow-down-s-line"></i>
                          {entry.changeValue}
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-foreground-400 text-sm">
                          <i className="ri-subtract-line"></i>
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/zonghe-saishi"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看完整排行榜
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}